import { useState } from "react";
import { Card } from "./Card";
import { Title } from "./Title";

interface CollapsibleCardProps {
    identifier: string;
    title: string;
    children: React.ReactNode | React.ReactNode[];
    disableCollapse?: boolean;
}

export const CollapsibleCard = ({ identifier, title, children, disableCollapse }: CollapsibleCardProps) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <Card identifier={identifier} className="h-min p-4">
            <div onClick={() => !disableCollapse && setIsCollapsed(!isCollapsed)} className={!disableCollapse ? "cursor-pointer" : ""}>
                <Title className="text-center mb-2 pb-2 border-b border-b-soft-elevation-0" text={title} />
            </div>
            <>
                {!isCollapsed && children}
            </>
        </Card>
    )
}
